import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { NAV } from "../data/content";
import { scrollToHash } from "../lib/smooth";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => { setScrolled(window.scrollY > 40); };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => { e.preventDefault(); setOpen(false); scrollToHash(href); };

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
        scrolled || open ? "bg-[#FAF8F5]/90 backdrop-blur-xl border-b border-[#E5DFD5] py-3" : "bg-transparent border-b border-transparent py-5"
      }`}
    >
      <div className="mx-auto flex max-w-[1440px] items-center justify-between px-5 sm:px-10">
        <a href="#top" onClick={(e) => go(e, "#top")} data-testid="brand-logo-link"><Logo /></a>
        <nav className="hidden items-center gap-9 lg:flex">
          {NAV.map((n) => (
            <a key={n.href} href={n.href} onClick={(e) => go(e, n.href)} data-testid={`nav-link-${n.label.toLowerCase()}`}
              className="link-underline text-[15px] text-[#3A3632] hover:text-[#1A1816]">{n.label}</a>
          ))}
          <a href="#contact" onClick={(e) => go(e, "#contact")} data-testid="nav-cta-book" className="btn-dark">Book a consultation</a>
        </nav>
        <button className="lg:hidden p-2" onClick={() => setOpen((o) => !o)} aria-label="Menu" data-testid="mobile-menu-toggle">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <nav className="lg:hidden border-t border-[#E5DFD5] px-5 pb-6 pt-4" data-testid="mobile-menu">
          {NAV.map((n) => (
            <a key={n.href} href={n.href} onClick={(e) => go(e, n.href)} data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              className="block border-b border-[#E5DFD5] py-4 font-display text-2xl">{n.label}</a>
          ))}
          <a href="#contact" onClick={(e) => go(e, "#contact")} data-testid="mobile-nav-book" className="btn-dark mt-6 w-full justify-center">Book a consultation</a>
        </nav>
      )}
    </header>
  );
};
